import { useState, useRef, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { logoWhiteUrl } from "../utils/publicAssets";
import "./NewHeader.css";

/* About Us — same as old navbar; Faculties is expandable to show sub-panel */
const ABOUT_ITEMS = [
  { text: "Our Institution", link: "/about/our-institution" },
  { text: "Message From Our President", link: "/about/message-president" },
  { text: "Executive Team", link: "/about/executive-team" },
  { text: "Teaching Staff", link: "/about/teaching-staff" },
  { text: "Faculties", expandable: true },
  { text: "Accreditation", link: "/about/accreditation" },
  { text: "Strategic Ambitions", link: "/about/strategic-ambition" },
];

const FACULTIES = [
  { name: "Faculty of Engineering", link: "/faculties/engineering" },
  { name: "Faculty of Diplomacy, International Relations & Politics", link: "/faculties/international-relations-diplomacy" },
  { name: "Faculty of Computer Science", link: "/faculties/computer-science" },
  { name: "Faculty of Business & Leadership", link: "/faculties/business-leadership" },
];

const ACADEMIC_TABS = [
  { name: "Bachelor's Degree", items: [{ name: "Currently Not Available", link: "/register-your-interest" }] },
  { name: "Master's Programme", items: [{ name: "Master of Arts in Global Business & Strategic Leadership", link: "/masters/leadership" }] },
  { name: "Undergraduate Certificate/Diploma", items: [{ name: "Currently Not Available", link: "/register-your-interest" }] },
  { name: "Postgraduate Certificate/Diploma", items: [
    { name: "Postgraduate Certificate In Global Business And Strategic Leadership", link: "/masters/postgraduate-certificate-leadership" },
    { name: "Postgraduate Diploma In Global Business And Strategic Leadership", link: "/masters/postgraduate-diploma-leadership" },
  ]},
  { name: "Executive Education Programme", items: [
    { name: "Advanced International Relations & Diplomatic Practice Course", link: "/executive/advanced-international-relations" },
    { name: "The Young Emerging Entrepreneur Course", link: "/executive/young-emerging-entrepreneur" },
    { name: "The Emerging Journalist Course", link: "/executive/emerging-journalist" },
    { name: "The Young Emerging Politician Course", link: "/executive/emerging-politician" },
    { name: "The Young Emerging International Relations & Diplomat Practice Course", link: "/executive/young-emerging-international-relations" },
    { name: "The Emerging Young Trade Specialist Course", link: "/executive/young-emerging-trade-specialist" },
  ]},
  { name: "Certified Courses", items: [
    { name: "Certified Data Analyst", link: "/certified/data-analyst" },
    { name: "Certified Business Consultant", link: "/certified/business-consultant" },
    { name: "Certified Executive Career Coach", link: "/certified/executive-career-coach" },
    { name: "Certified Women Leadership & Gender Changemaker", link: "/certified/womens-leadership-gender" },
    { name: "Certified Agile Thought Leader", link: "/certified/agile-thought-leader" },
  ]},
  { name: "Executive Education for Government Officials", items: [
    { name: "Local Governance and Decentralisation", link: "/executive-government/governance-and-decentralisation" },
    { name: "Strategic Public Policy Formulation and Implementation", link: "/executive-government/public-policy-formation" },
    { name: "Digital Transformation and e-Governance", link: "/executive-government/digital-transformation" },
    { name: "Ethical Leadership, Transparency, and Accountability", link: "/executive-government/leadership-tranparency-accountability" },
    { name: "Effective Leadership in State-Owned Institutions", link: "/executive-government/leadership-state-owned" },
  ]},
  { name: "Executive Summer School", items: [{ name: "The Executive Summer School in Diplomacy and International Relations", link: "/executive-summerschool" }] },
  { name: "London Executive Week", items: [{ name: "London Executive Leadership, Strategy & Culture Week 2026", link: "/london-executive-week" }] },
];

const PARTNERSHIP_ITEMS = [
  { text: "Become a Study Centre Partner", link: "/study-centre-partner" },
  { text: "Corporate Partnership", link: "/corporate-partnership" },
];
const MA_APPLY_URL = "https://admissions.eusbd.eu/esbd-apply/MA-GBSL/";

export default function NewHeader() {
  const navRef = useRef(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [aboutFacultiesOpen, setAboutFacultiesOpen] = useState(false);
  const [academicTab, setAcademicTab] = useState(ACADEMIC_TABS[0].name);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileRootOpen, setMobileRootOpen] = useState(null);
  const [mobileAboutFacultiesOpen, setMobileAboutFacultiesOpen] = useState(false);
  const [mobileAcademicTabOpen, setMobileAcademicTabOpen] = useState(null);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1072px)");
    const apply = () => setIsMobile(mq.matches);
    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply);
    else mq.addListener(apply);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", apply);
      else mq.removeListener(apply);
    };
  }, []);

  useEffect(() => {
    if (!openDropdown) return;
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenDropdown(null);
        setAboutFacultiesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [openDropdown]);

  const closeAll = () => {
    setOpenDropdown(null);
    setMobileOpen(false);
    setAboutFacultiesOpen(false);
    setMobileRootOpen(null);
    setMobileAboutFacultiesOpen(false);
    setMobileAcademicTabOpen(null);
  };

  const toggleDropdown = (key) => {
    setOpenDropdown((prev) => (prev === key ? null : key));
    if (key !== "about") setAboutFacultiesOpen(false);
  };

  const currentAcademicItems = ACADEMIC_TABS.find((t) => t.name === academicTab)?.items ?? [];

  const toggleMobileRoot = (key) => {
    setMobileRootOpen((prev) => {
      const next = prev === key ? null : key;
      if (next !== "about") setMobileAboutFacultiesOpen(false);
      if (next !== "academic") setMobileAcademicTabOpen(null);
      return next;
    });
  };

  return (
    <nav className="th-nav" ref={navRef}>
      <Link to="/" className="th-nav__logo" onClick={closeAll}>
        <img src={logoWhiteUrl} alt="European School of Business & Diplomacy" className="th-nav__logo-img" />
      </Link>

      <div className={`th-nav__menu ${mobileOpen ? "th-nav__menu--open" : ""}`}>
        <div className="th-nav__wrap">
          <ul className={`th-nav__links ${mobileOpen ? "th-nav__links--open" : ""}`}>
            <li>
              <Link to="/" className="th-nav__link" onClick={closeAll}>Home</Link>
            </li>
            {isMobile ? (
              <>
                <li>
                  <button
                    type="button"
                    className={`th-nav__link th-nav__m-dd ${mobileRootOpen === "about" ? "th-nav__link--active" : ""}`}
                    onClick={() => toggleMobileRoot("about")}
                    aria-expanded={mobileRootOpen === "about"}
                  >
                    <span>About Us</span>
                    <span className={`th-nav__m-arrow-circle ${mobileRootOpen === "about" ? "th-nav__m-arrow-circle--open" : ""}`} aria-hidden>
                      <span className="th-nav__m-arrow-glyph">⌄</span>
                    </span>
                  </button>
                  <div className={`th-nav__m-collapse ${mobileRootOpen === "about" ? "th-nav__m-collapse--open" : ""}`} aria-hidden={mobileRootOpen !== "about"}>
                    <div className="th-nav__m-collapse-inner">
                      {ABOUT_ITEMS.map((item, i) =>
                        item.expandable ? (
                          <Fragment key={i}>
                            <button
                              type="button"
                              className={`th-nav__m-subbtn ${mobileAboutFacultiesOpen ? "th-nav__m-subbtn--open" : ""}`}
                              onClick={() => setMobileAboutFacultiesOpen((p) => !p)}
                              aria-expanded={mobileAboutFacultiesOpen}
                            >
                              <span>{item.text}</span>
                              <span className={`th-nav__m-arrow-circle ${mobileAboutFacultiesOpen ? "th-nav__m-arrow-circle--open" : ""}`} aria-hidden>
                                <span className="th-nav__m-arrow-glyph">⌄</span>
                              </span>
                            </button>
                            <div className={`th-nav__m-collapse th-nav__m-collapse--nested ${mobileAboutFacultiesOpen ? "th-nav__m-collapse--open" : ""}`} aria-hidden={!mobileAboutFacultiesOpen}>
                              <div className="th-nav__m-collapse-inner">
                                {FACULTIES.map((f, j) => (
                                  <Link key={j} to={f.link} className="th-nav__m-link th-nav__m-link--nested" onClick={closeAll}>
                                    {f.name}
                                  </Link>
                                ))}
                              </div>
                            </div>
                          </Fragment>
                        ) : (
                          <Link key={i} to={item.link} className="th-nav__m-link" onClick={closeAll}>
                            {item.text}
                          </Link>
                        )
                      )}
                    </div>
                  </div>
                </li>

                <li>
                  <button
                    type="button"
                    className={`th-nav__link th-nav__m-dd ${mobileRootOpen === "partnerships" ? "th-nav__link--active" : ""}`}
                    onClick={() => toggleMobileRoot("partnerships")}
                    aria-expanded={mobileRootOpen === "partnerships"}
                  >
                    <span>Partnerships</span>
                    <span className={`th-nav__m-arrow-circle ${mobileRootOpen === "partnerships" ? "th-nav__m-arrow-circle--open" : ""}`} aria-hidden>
                      <span className="th-nav__m-arrow-glyph">⌄</span>
                    </span>
                  </button>
                  <div className={`th-nav__m-collapse ${mobileRootOpen === "partnerships" ? "th-nav__m-collapse--open" : ""}`} aria-hidden={mobileRootOpen !== "partnerships"}>
                    <div className="th-nav__m-collapse-inner">
                      {PARTNERSHIP_ITEMS.map((item) => (
                        <Link key={item.link} to={item.link} className="th-nav__m-link" onClick={closeAll}>
                          {item.text}
                        </Link>
                      ))}
                    </div>
                  </div>
                </li>

                <li>
                  <button
                    type="button"
                    className={`th-nav__link th-nav__m-dd ${mobileRootOpen === "academic" ? "th-nav__link--active" : ""}`}
                    onClick={() => toggleMobileRoot("academic")}
                    aria-expanded={mobileRootOpen === "academic"}
                  >
                    <span>Academic Programmes</span>
                    <span className={`th-nav__m-arrow-circle ${mobileRootOpen === "academic" ? "th-nav__m-arrow-circle--open" : ""}`} aria-hidden>
                      <span className="th-nav__m-arrow-glyph">⌄</span>
                    </span>
                  </button>
                  <div className={`th-nav__m-collapse ${mobileRootOpen === "academic" ? "th-nav__m-collapse--open" : ""}`} aria-hidden={mobileRootOpen !== "academic"}>
                    <div className="th-nav__m-collapse-inner">
                      {ACADEMIC_TABS.map((tab) => (
                        <Fragment key={tab.name}>
                          <button
                            type="button"
                            className={`th-nav__m-subbtn ${mobileAcademicTabOpen === tab.name ? "th-nav__m-subbtn--open" : ""}`}
                            onClick={() => setMobileAcademicTabOpen((p) => (p === tab.name ? null : tab.name))}
                            aria-expanded={mobileAcademicTabOpen === tab.name}
                          >
                            <span>{tab.name}</span>
                            <span className={`th-nav__m-arrow-circle ${mobileAcademicTabOpen === tab.name ? "th-nav__m-arrow-circle--open" : ""}`} aria-hidden>
                              <span className="th-nav__m-arrow-glyph">⌄</span>
                            </span>
                          </button>
                          <div className={`th-nav__m-collapse th-nav__m-collapse--nested ${mobileAcademicTabOpen === tab.name ? "th-nav__m-collapse--open" : ""}`} aria-hidden={mobileAcademicTabOpen !== tab.name}>
                            <div className="th-nav__m-collapse-inner">
                              {tab.items.map((subItem, i) => (
                                <Link key={i} to={subItem.link} className="th-nav__m-link th-nav__m-link--nested" onClick={closeAll}>
                                  {subItem.name}
                                </Link>
                              ))}
                            </div>
                          </div>
                        </Fragment>
                      ))}
                    </div>
                  </div>
                </li>
              </>
            ) : (
              <>
                <li>
                  <button type="button" className={`th-nav__link th-nav__link--dd ${openDropdown === "about" ? "th-nav__link--active" : ""}`} onClick={() => toggleDropdown("about")} aria-expanded={openDropdown === "about"}>
                    About Us
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    className={`th-nav__link th-nav__link--dd ${openDropdown === "partnerships" ? "th-nav__link--active" : ""}`}
                    onClick={() => toggleDropdown("partnerships")}
                    aria-expanded={openDropdown === "partnerships"}
                  >
                    Partnerships
                  </button>
                </li>
                <li>
                  <button type="button" className={`th-nav__link th-nav__link--dd ${openDropdown === "academic" ? "th-nav__link--active" : ""}`} onClick={() => toggleDropdown("academic")} aria-expanded={openDropdown === "academic"}>
                    Academic Programmes
                  </button>
                </li>
              </>
            )}
            <li>
              <Link to="/admissions" className="th-nav__link" onClick={closeAll}>Admissions</Link>
            </li>
            <li>
              <Link to="/career" className="th-nav__link" onClick={closeAll}>Careers</Link>
            </li>
            <li>
              <a href="https://elearn.eusbd.eu" target="_blank" rel="noopener noreferrer" className="th-nav__link" onClick={closeAll}>Login</a>
            </li>
            <li>
              <a href={MA_APPLY_URL} target="_blank" rel="noreferrer" className="th-nav__cta" onClick={closeAll}>Apply Now</a>
            </li>
          </ul>
        </div>

        {!isMobile && openDropdown === "about" && (
          <div className="th-nav__dd th-nav__dd--about" role="menu">
            <div className="th-nav__dd-back-wrap">
              <button type="button" className="th-nav__dd-back" onClick={() => setOpenDropdown(null)} aria-label="Back to menu">
                ← Back
              </button>
              <span className="th-nav__dd-back-title">About Us</span>
            </div>
            <div className="th-nav__dd-cols">
              <div className="th-nav__dd-col">
                <h2 className="th-nav__dd-heading">IN THIS SECTION</h2>
                <div className="th-nav__dd-list">
                  {ABOUT_ITEMS.map((item, i) =>
                    item.expandable ? (
                      <Fragment key={i}>
                        <button type="button" className={`th-nav__dd-item th-nav__dd-item--expandable ${aboutFacultiesOpen ? "th-nav__dd-item--active" : ""}`} onClick={() => setAboutFacultiesOpen((p) => !p)}>
                          {item.text}
                          <span className="th-nav__dd-arrow" aria-hidden>›</span>
                        </button>
                        <div className={`th-nav__dd-collapse th-nav__dd-collapse--mobile ${aboutFacultiesOpen ? "th-nav__dd-collapse--open" : ""}`} aria-hidden={!aboutFacultiesOpen}>
                          <div className="th-nav__dd-collapse-inner">
                            {FACULTIES.map((f, j) => (
                              <Link key={j} to={f.link} className="th-nav__dd-item th-nav__dd-item--sub" onClick={closeAll}>{f.name}</Link>
                            ))}
                          </div>
                        </div>
                      </Fragment>
                    ) : (
                      <Link key={i} to={item.link} className="th-nav__dd-item" onClick={closeAll}>{item.text}</Link>
                    )
                  )}
                </div>
              </div>
              <div className="th-nav__dd-vdiv th-nav__dd-vdiv--desktop" aria-hidden />
              <div className="th-nav__dd-col th-nav__dd-col--right">
                {aboutFacultiesOpen ? (
                  <>
                    <h2 className="th-nav__dd-heading">FACULTIES</h2>
                    <div className="th-nav__dd-list">
                      {FACULTIES.map((f, i) => (
                        <Link key={i} to={f.link} className="th-nav__dd-item" onClick={closeAll}>{f.name}</Link>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="th-nav__dd-placeholder">Select an option from the left.</div>
                )}
              </div>
            </div>
          </div>
        )}

        {!isMobile && openDropdown === "partnerships" && (
          <div className="th-nav__dd th-nav__dd--academic" role="menu">
            <div className="th-nav__dd-back-wrap">
              <button
                type="button"
                className="th-nav__dd-back"
                onClick={() => setOpenDropdown(null)}
                aria-label="Back to menu"
              >
                ← Back
              </button>
              <span className="th-nav__dd-back-title">Partnerships</span>
            </div>
            <div className="th-nav__dd-cols">
              <div className="th-nav__dd-col">
                <h2 className="th-nav__dd-heading">IN THIS SECTION</h2>
                <div className="th-nav__dd-list">
                  {PARTNERSHIP_ITEMS.map((item) => (
                    <Link
                      key={item.link}
                      to={item.link}
                      className="th-nav__dd-item"
                      onClick={closeAll}
                    >
                      {item.text}
                    </Link>
                  ))}
                </div>
              </div>
              {/* <div className="th-nav__dd-vdiv th-nav__dd-vdiv--desktop" aria-hidden />
              <div className="th-nav__dd-col th-nav__dd-col--right">
                <h2 className="th-nav__dd-heading">PARTNERSHIPS</h2>
                <div className="th-nav__dd-list">
                  {PARTNERSHIP_ITEMS.map((item) => (
                    <Link
                      key={`${item.link}-r`}
                      to={item.link}
                      className="th-nav__dd-item"
                      onClick={closeAll}
                    >
                      {item.text}
                    </Link>
                  ))}
                </div>
              </div> */}
            </div>
          </div>
        )}

        {!isMobile && openDropdown === "academic" && (
          <div className="th-nav__dd th-nav__dd--academic" role="menu">
            <div className="th-nav__dd-back-wrap">
              <button type="button" className="th-nav__dd-back" onClick={() => setOpenDropdown(null)} aria-label="Back to menu">
                ← Back
              </button>
              <span className="th-nav__dd-back-title">Academic Programmes</span>
            </div>
            <div className="th-nav__dd-cols">
              <div className="th-nav__dd-col">
                <h2 className="th-nav__dd-heading">IN THIS SECTION</h2>
                <div className="th-nav__dd-list">
                  {ACADEMIC_TABS.map((tab) => (
                    <Fragment key={tab.name}>
                      <button type="button" className={`th-nav__dd-item th-nav__dd-item--expandable ${academicTab === tab.name ? "th-nav__dd-item--active" : ""}`} onClick={() => setAcademicTab(tab.name)}>
                        {tab.name}
                        <span className="th-nav__dd-arrow" aria-hidden>›</span>
                      </button>
                      <div className={`th-nav__dd-collapse th-nav__dd-collapse--mobile ${academicTab === tab.name ? "th-nav__dd-collapse--open" : ""}`} aria-hidden={academicTab !== tab.name}>
                        <div className="th-nav__dd-collapse-inner">
                          {tab.items.map((subItem, i) => (
                            <Link key={i} to={subItem.link} className="th-nav__dd-item th-nav__dd-item--sub" onClick={closeAll}>{subItem.name}</Link>
                          ))}
                        </div>
                      </div>
                    </Fragment>
                  ))}
                </div>
              </div>
              <div className="th-nav__dd-vdiv th-nav__dd-vdiv--desktop" aria-hidden />
              <div className="th-nav__dd-col th-nav__dd-col--right">
                <h2 className="th-nav__dd-heading">{academicTab.toUpperCase()}</h2>
                <div className="th-nav__dd-list">
                  {currentAcademicItems.map((item, i) => (
                    <Link key={i} to={item.link} className="th-nav__dd-item" onClick={closeAll}>{item.name}</Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <button type="button" className={`th-nav__burger ${mobileOpen ? "th-nav__burger--open" : ""}`} onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu">
        <span /><span /><span />
      </button>
    </nav>
  );
}
